import React from 'react';
import style from './style';
import EAIcon from '../../common/EAIcon';
import i18next from 'i18next';

const ModificationDate = ({ date }) => {
  const { classes } = style();
  return (
    <div className={classes.root}>
      <EAIcon icon={'context/red_calendar'} />
      <span className={classes.text}>{i18next.t('updated')}: </span>
      <span className={classes.date}>{date}</span>
    </div>
  );
};

export default ModificationDate;
